export const IsomerWaitingLine = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => {
  return (
    <svg
      width="680"
      height="192"
      viewBox="0 0 680 192"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_6647_121640)">
        <rect width="680" height="192" fill="#F8FAFE" />
        <path
          d="M341 10V9C341 7.89543 341.895 7 343 7H354C355.105 7 356 7.89543 356 9V10C356 11.1046 355.105 12 354 12H353.5C352.395 12 351.5 12.8954 351.5 14V24C351.5 25.1046 352.395 26 353.5 26H354C355.105 26 356 26.8954 356 28V31C356 32.1046 355.105 33 354 33H343C341.895 33 341 32.1046 341 31V28C341 26.8954 341.895 26 343 26H344C345.105 26 346 25.1046 346 24V14C346 12.8954 345.105 12 344 12H343C341.895 12 341 11.1046 341 10Z"
          fill="white"
        />
        <path
          d="M371.5 7H360C358.895 7 358 7.89543 358 9V21.5C358 22.6046 358.895 23.5 360 23.5H364.75C365.44 23.5 366 24.0596 366 24.75C366 25.4404 365.44 26 364.75 26H360C358.895 26 358 26.8954 358 28V31C358 32.1046 358.895 33 360 33H371.5C372.605 33 373.5 32.1046 373.5 31V19C373.5 17.8954 372.605 17 371.5 17H365C364.172 17 363.5 16.3284 363.5 15.5C363.5 14.6716 364.172 14 365 14H371.5C372.605 14 373.5 13.1046 373.5 12V9C373.5 7.89543 372.605 7 371.5 7Z"
          fill="white"
        />
        <path
          d="M376 31V9C376 7.89543 376.895 7 378 7H387.5C388.605 7 389.5 7.89543 389.5 9V31C389.5 32.1046 388.605 33 387.5 33H378C376.895 33 376 32.1046 376 31Z"
          fill="white"
        />
        <path
          d="M392 31V9C392 7.89543 392.895 7 394 7H400.5H407C408.105 7 409 7.89543 409 9V31C409 32.1046 408.105 33 407 33H406.5C405.395 33 404.5 32.1046 404.5 31V24.25C404.5 23.8358 404.164 23.5 403.75 23.5C403.336 23.5 403 23.8358 403 24.25V28C403 29.1046 402.105 30 401 30H400C398.895 30 398 29.1046 398 28V24.25C398 23.8358 397.664 23.5 397.25 23.5C396.836 23.5 396.5 23.8358 396.5 24.25V31C396.5 32.1046 395.605 33 394.5 33H394C392.895 33 392 32.1046 392 31Z"
          fill="white"
        />
        <path
          d="M411.5 31V9C411.5 7.89543 412.395 7 413.5 7H423C424.105 7 425 7.89543 425 9V12C425 13.1046 424.105 14 423 14H419C418.172 14 417.5 14.6716 417.5 15.5C417.5 16.3284 418.172 17 419 17H423C424.105 17 425 17.8954 425 19V21.5C425 22.6046 424.105 23.5 423 23.5H419.25C418.284 23.5 417.5 24.2835 417.5 25.25C417.5 26.2165 418.284 27 419.25 27H423C424.105 27 425 27.8954 425 29V31C425 32.1046 424.105 33 423 33H413.5C412.395 33 411.5 32.1046 411.5 31Z"
          fill="white"
        />
        <path
          d="M427.5 31V9C427.5 7.89543 428.395 7 429.5 7H442C443.105 7 444 7.89543 444 9V18C444 19.1046 443.105 20 442 20H441.25C440.56 20 440 20.5596 440 21.25C440 21.9404 440.56 22.5 441.25 22.5H442C443.105 22.5 444 23.3954 444 24.5V31C444 32.1046 443.105 33 442 33H440.5C439.395 33 438.5 32.1046 438.5 31V30C438.5 28.8954 437.605 28 436.5 28H435C433.895 28 433 28.8954 433 30V31C433 32.1046 432.105 33 431 33H429.5C428.395 33 427.5 32.1046 427.5 31Z"
          fill="white"
        />
        <path
          d="M383 14V25.5M400.5 7H407C408.105 7 409 7.89543 409 9V31C409 32.1046 408.105 33 407 33H406.5C405.395 33 404.5 32.1046 404.5 31V24.25C404.5 23.8358 404.164 23.5 403.75 23.5V23.5C403.336 23.5 403 23.8358 403 24.25V28C403 29.1046 402.105 30 401 30H400C398.895 30 398 29.1046 398 28V24.25C398 23.8358 397.664 23.5 397.25 23.5V23.5C396.836 23.5 396.5 23.8358 396.5 24.25V31C396.5 32.1046 395.605 33 394.5 33H394C392.895 33 392 32.1046 392 31V9C392 7.89543 392.895 7 394 7H400.5ZM400.5 7V11M435 12V18M444 9V18C444 19.1046 443.105 20 442 20H441.25C440.56 20 440 20.5596 440 21.25V21.25C440 21.9404 440.56 22.5 441.25 22.5H442C443.105 22.5 444 23.3954 444 24.5V31C444 32.1046 443.105 33 442 33H440.5C439.395 33 438.5 32.1046 438.5 31V30C438.5 28.8954 437.605 28 436.5 28H435C433.895 28 433 28.8954 433 30V31C433 32.1046 432.105 33 431 33H429.5C428.395 33 427.5 32.1046 427.5 31V9C427.5 7.89543 428.395 7 429.5 7H442C443.105 7 444 7.89543 444 9ZM425 9V12C425 13.1046 424.105 14 423 14H419C418.172 14 417.5 14.6716 417.5 15.5V15.5C417.5 16.3284 418.172 17 419 17H423C424.105 17 425 17.8954 425 19V21.5C425 22.6046 424.105 23.5 423 23.5H419.25C418.284 23.5 417.5 24.2835 417.5 25.25V25.25C417.5 26.2165 418.284 27 419.25 27H423C424.105 27 425 27.8954 425 29V31C425 32.1046 424.105 33 423 33H413.5C412.395 33 411.5 32.1046 411.5 31V9C411.5 7.89543 412.395 7 413.5 7H423C424.105 7 425 7.89543 425 9ZM389.5 9V31C389.5 32.1046 388.605 33 387.5 33H378C376.895 33 376 32.1046 376 31V9C376 7.89543 376.895 7 378 7H387.5C388.605 7 389.5 7.89543 389.5 9ZM360 23.5H364.75C365.44 23.5 366 24.0596 366 24.75V24.75C366 25.4404 365.44 26 364.75 26H360C358.895 26 358 26.8954 358 28V31C358 32.1046 358.895 33 360 33H371.5C372.605 33 373.5 32.1046 373.5 31V19C373.5 17.8954 372.605 17 371.5 17H365C364.172 17 363.5 16.3284 363.5 15.5V15.5C363.5 14.6716 364.172 14 365 14H371.5C372.605 14 373.5 13.1046 373.5 12V9C373.5 7.89543 372.605 7 371.5 7H360C358.895 7 358 7.89543 358 9V21.5C358 22.6046 358.895 23.5 360 23.5ZM356 9V10C356 11.1046 355.105 12 354 12H353.5C352.395 12 351.5 12.8954 351.5 14V24C351.5 25.1046 352.395 26 353.5 26H354C355.105 26 356 26.8954 356 28V31C356 32.1046 355.105 33 354 33H343C341.895 33 341 32.1046 341 31V28C341 26.8954 341.895 26 343 26H344C345.105 26 346 25.1046 346 24V14C346 12.8954 345.105 12 344 12H343C341.895 12 341 11.1046 341 10V9C341 7.89543 341.895 7 343 7H354C355.105 7 356 7.89543 356 9Z"
          stroke="#AA90FA"
        />
        <path
          d="M341 48.3333V39C341 37.8954 341.895 37 343 37H446.11C447.215 37 448.11 36.1046 448.11 35V30.2876C448.11 28.4452 450.39 27.5828 451.609 28.9641L462.832 41.6764C463.499 42.4326 463.499 43.5674 462.832 44.3236L451.609 57.036C450.39 58.4172 448.11 57.5548 448.11 55.7124V52.3333C448.11 51.2288 447.215 50.3333 446.11 50.3333H343C341.895 50.3333 341 49.4379 341 48.3333Z"
          fill="white"
          stroke="#AA90FA"
        />
        <path
          d="M197.163 172.873H233.402C238.81 172.873 243.193 177.257 243.193 182.664C243.193 188.071 238.81 192.455 233.402 192.455H197.163V172.873L197.163 172.873Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M149.603 172.62H182.409V192.458H149.603C146.973 192.458 144.45 191.414 142.59 189.554C140.731 187.694 139.686 185.171 139.686 182.541C139.686 177.064 144.126 172.624 149.603 172.624V172.62Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M113.461 89.7137L172.911 72.9474L166.865 52.509L109.287 63.0444L105.466 63.8938C87.5145 67.8152 78.0381 87.5741 86.2207 104.012C86.2207 104.012 105.098 134.732 179.359 126.08C211.356 117.044 188.322 98.6517 183.429 96.3241C178.535 93.9966 113.461 89.7137 113.461 89.7137Z"
          fill="#AA90FA"
        />
        <path
          d="M172.911 72.9472L180.631 56.3941L175.286 50.1126C172.587 46.9443 167.871 46.4662 164.591 49.0283L158.086 54.1135L140.416 57.3482L145.609 80.6491L172.911 72.9472Z"
          fill="#EBA687"
        />
        <path
          d="M257.1 115.179L251.206 133.25L202.649 100.3C199.031 97.8477 194.927 96.2056 190.617 95.4855L177.324 93.27L193.346 145.152L227.934 160.411C262.269 171.854 276.42 170.577 280.869 148.69L276.72 131.574"
          fill="white"
        />
        <mask
          id="mask0_6647_121640"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="177"
          y="93"
          width="105"
          height="74"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M251.206 130.391V133.25L202.649 100.3C199.031 97.8477 194.927 96.2056 190.617 95.4855L177.324 93.27L193.346 145.152L227.934 160.411C262.269 171.854 275.901 166.947 280.35 145.059L281.387 133.25"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_6647_121640)">
          <path d="M192.999 55.3784V182.537" stroke="#272D41" />
          <path d="M210.871 55.3784V182.537" stroke="#272D41" />
          <path d="M228.743 55.3784V182.537" stroke="#272D41" />
          <path d="M246.616 55.3784V182.537" stroke="#272D41" />
          <path d="M264.484 55.3784V182.537" stroke="#272D41" />
          <path d="M76.1043 97.466H323.049" stroke="#272D41" />
          <path d="M76.1043 119.975H323.049" stroke="#272D41" />
          <path d="M76.1043 142.481H323.049" stroke="#272D41" />
          <path d="M76.1043 164.99H323.049" stroke="#272D41" />
        </g>
        <path
          d="M251.206 133.25L202.649 100.3C199.031 97.8477 194.927 96.2056 190.617 95.4855L177.324 93.27L193.346 145.152L227.934 160.411"
          stroke="#272D41"
        />
        <path
          d="M209.996 289.308L206.31 262.997L172.419 140.62C172.419 140.62 187.053 140.981 215.924 158.127C229.994 190.503 239.937 245.074 246.095 288.26"
          fill="#2164DA"
        />
        <path
          d="M209.996 289.308L206.31 262.997L172.419 140.62C172.419 140.62 187.053 140.981 215.924 158.127C229.994 190.503 239.937 245.074 246.095 288.26"
          stroke="#272D41"
        />
        <path
          d="M153.568 276.359L161.555 257.706L159.52 169.714L193.855 163.1C193.855 163.1 211.995 232.103 194.502 274.132C192.012 280.11 189.421 285.969 186.793 291.64H145.79L153.568 276.359Z"
          fill="#2164DA"
        />
        <path
          d="M145.79 291.64L153.568 276.359L161.555 257.706L159.52 169.714L193.855 163.1"
          stroke="#272D41"
        />
        <path
          d="M198.962 189.036C202.576 212.962 205.153 248.544 194.502 274.132C192.012 280.11 189.421 285.969 186.793 291.64"
          stroke="#272D41"
        />
        <path
          d="M198.962 189.036C201.398 205.086 203.354 226.385 201.156 246.393L206.317 262.903C206.317 262.903 213.69 233.91 207.08 211.021C200.469 188.132 198.962 189.036 198.962 189.036Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M145.609 80.6494L140.412 57.3486L129.898 59.2714L135.312 83.5516L145.609 80.6494Z"
          fill="#EBA687"
        />
        <path d="M135.312 83.5513L163.337 75.7229" stroke="#272D41" />
        <path
          d="M161.049 167.531L219.762 166.021L201.228 119.719C198.319 108.153 191.672 93.7363 179.868 95.5615L180.23 94.9254C168.836 96.6915 160.483 106.578 160.644 118.107L161.049 167.531Z"
          fill="white"
          stroke="#3C4764"
        />
        <path
          d="M161.049 167.531L219.762 166.021L201.228 119.719C198.319 108.153 191.672 93.7363 179.868 95.5615L180.23 94.9254C168.836 96.6915 160.483 106.578 160.644 118.107L161.049 167.531Z"
          fill="white"
          stroke="#3C4764"
        />
        <path
          d="M208.757 122.263L219.762 166.02L161.049 167.531L160.644 118.107C160.479 106.57 168.841 96.6746 180.244 94.9144"
          stroke="#272D41"
        />
        <path
          d="M139.686 182.537L140.098 179.707C139.824 180.626 139.685 181.579 139.686 182.537Z"
          fill="white"
          stroke="#3C4764"
        />
        <path
          d="M170.269 99.013C170.439 99.9864 170.698 100.942 171.043 101.868C173.612 108.779 180.324 112.66 186.034 110.542C189.833 109.129 192.225 105.414 192.648 101.048C189.32 97.1408 185.102 94.759 179.868 95.5686L180.23 94.9325C176.634 95.4873 173.221 96.8856 170.269 99.013H170.269Z"
          fill="#EBA687"
          stroke="#272D41"
        />
        <mask
          id="mask1_6647_121640"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="140"
          y="94"
          width="41"
          height="86"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M149.603 172.62H180.729L173.5 94.5531L151.374 102.183L140.098 179.708C141.351 175.503 145.216 172.621 149.603 172.62Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask1_6647_121640)">
          <path
            d="M149.603 172.62H180.729L173.5 94.5531L151.374 102.183L140.098 179.708C141.351 175.503 145.216 172.621 149.603 172.62Z"
            fill="white"
          />
          <path d="M157.258 55.3784V182.537" stroke="#272D41" />
          <path d="M175.126 55.3784V182.537" stroke="#272D41" />
          <path d="M76.1043 97.466H323.049" stroke="#272D41" />
          <path d="M76.1043 119.975H323.049" stroke="#272D41" />
          <path d="M76.1043 142.481H323.049" stroke="#272D41" />
          <path d="M76.1043 164.99H323.049" stroke="#272D41" />
        </g>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M149.603 172.62H180.729L173.5 94.5531L151.374 102.183L140.098 179.708C141.351 175.503 145.216 172.621 149.603 172.62V172.62Z"
          stroke="#272D41"
        />
        <mask
          id="mask2_6647_121640"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="76"
          y="59"
          width="98"
          height="75"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M173.511 94.542C168.614 92.2109 130.784 91.0001 130.784 91.0001L135.312 83.5693L129.891 59.289L109.29 63.0622L105.466 63.8935C87.5145 67.8005 67.9688 87.1691 79.4114 106.751C79.4114 106.751 92.8888 140.067 173.02 132.69"
            fill="white"
          />
        </mask>
        <g mask="url(#mask2_6647_121640)">
          <path
            d="M173.511 94.542C168.614 92.2108 130.784 91 130.784 91L135.312 83.5692L129.891 59.2889L109.29 63.0622L105.466 63.8934C87.5145 67.8004 67.9688 87.169 79.4114 106.751C79.4114 106.751 92.8888 140.067 173.02 132.69"
            fill="white"
          />
          <path d="M85.7689 55.3783V182.537" stroke="#272D41" />
          <path d="M103.641 55.3783V182.537" stroke="#272D41" />
          <path d="M121.513 55.3783V182.537" stroke="#272D41" />
          <path d="M139.386 55.3783V182.537" stroke="#272D41" />
          <path d="M157.258 55.3783V182.537" stroke="#272D41" />
          <path d="M76.1044 74.9602H323.049" stroke="#272D41" />
          <path d="M76.1044 97.4658H323.049" stroke="#272D41" />
          <path d="M76.1044 119.975H323.049" stroke="#272D41" />
        </g>
        <path
          d="M183.428 96.3239C178.535 93.9927 130.784 91.0002 130.784 91.0002L135.312 83.5694L129.891 59.2891L109.29 63.0623L105.466 63.8936C87.5145 67.8005 67.9688 87.1691 79.4114 106.751C79.4114 106.751 92.8888 140.067 173.019 132.69"
          stroke="#272D41"
        />
        <path
          d="M122.139 60.7169L127.509 88.7379C127.813 90.1244 128.656 91.333 129.852 92.0966C131.048 92.8603 132.499 93.1161 133.885 92.8075L140.958 90.4908L135.363 83.6238L130.021 59.1953L122.139 60.7169Z"
          fill="#AA90FA"
          stroke="#272D41"
        />
        <path
          d="M135.902 86.1969C136.572 89.0441 139.408 90.8225 142.263 90.1861C145.118 89.5498 146.931 86.7355 146.329 83.873L145.606 80.6491L135.309 83.5404L135.902 86.1969Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M128.756 91.0798L102.81 97.0866L128.756 91.0798Z"
          fill="white"
        />
        <path d="M128.756 91.0798L102.81 97.0866" stroke="#3C4764" />
        <path
          d="M199.244 56.9869L200.444 63.4925C201.033 66.673 198.145 69.8716 194 70.6378L187.755 71.7943L185.149 64.7285L199.244 56.9869Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <circle
          cx="197.22"
          cy="58.0061"
          r="5.97791"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M171.809 76.5361L174.013 99.6635L189.486 102.237L184.357 74.476"
          fill="#EBA687"
        />
        <path
          d="M189.489 102.237L184.357 74.476"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M171.809 76.5362L174.013 99.6636"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M186.096 83.8767C186.096 83.8767 182.409 84.9212 179.334 83.6815C180.87 87.7945 187.523 91.6111 187.523 91.6111L186.096 83.8767Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <circle cx="181.708" cy="74.8378" r="10.0439" fill="#EBA687" />
        <path
          d="M179.514 84.6395C183.493 85.5309 187.616 83.929 189.95 80.5851C192.284 77.2412 192.365 72.8185 190.156 69.3912C187.946 65.9639 183.885 64.2118 179.876 64.9565"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M170.305 59.2279L174.917 58.375C174.492 56.031 175.753 53.7067 177.95 52.7843C180.146 51.8618 182.688 52.5889 184.065 54.533C184.449 51.2174 187.201 48.682 190.537 48.5717C193.873 48.4613 196.788 50.8091 197.39 54.0921V54.2186C198.507 60.2951 194.494 66.1288 188.42 67.2587L180.165 68.7803C181.932 74.1438 179.507 76.4026 179.507 76.4026C179.507 76.4026 178.676 71.9029 176.283 71.5668C173.891 71.2307 173.273 76.2653 176.757 76.9122C177.754 83.7106 172.499 84.6828 172.499 84.6828C167.714 82.3914 164.631 78.4158 162.65 74.3859C161.18 71.3908 161.2 67.8795 162.704 64.9012C164.208 61.923 167.022 59.8227 170.305 59.2279Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <mask
          id="mask3_6647_121640"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="188"
          y="95"
          width="54"
          height="83"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M188.261 95.8145L200.91 172.873H233.399C236.151 172.871 238.776 174.031 240.627 176.068L241.91 177.705L218.779 120.738"
            fill="white"
          />
        </mask>
        <g mask="url(#mask3_6647_121640)">
          <path
            d="M188.261 95.8146L200.91 172.873H233.399C236.151 172.871 238.776 174.031 240.627 176.068L241.91 177.705L218.779 120.738"
            fill="white"
          />
          <path d="M192.999 55.3784V182.537" stroke="#272D41" />
          <path d="M210.871 55.3784V182.537" stroke="#272D41" />
          <path d="M228.744 55.3784V182.537" stroke="#272D41" />
          <path d="M76.1045 97.4659H323.049" stroke="#272D41" />
          <path d="M76.1045 119.975H323.049" stroke="#272D41" />
          <path d="M76.1045 142.481H323.049" stroke="#272D41" />
          <path d="M76.1045 164.99H323.049" stroke="#272D41" />
        </g>
        <path
          d="M187.83 93.27L200.914 172.873H233.402C236.154 172.871 238.779 174.031 240.631 176.068L241.914 177.705L218.783 120.738"
          stroke="#272D41"
        />
        <path
          d="M252.131 130.406L248.278 141.845L252.131 130.406Z"
          fill="white"
        />
        <path d="M252.131 130.406L248.278 141.845" stroke="#3C4764" />
        <path
          d="M235.817 162.699C235.817 162.699 241.411 164.224 246.095 164.506C238.766 155.066 219.762 123.167 219.762 123.167L235.817 162.699Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M173.001 132.69C173.001 132.69 152.119 134.479 146.791 133.713C146.311 137.009 144.305 150.805 144.305 150.805C144.305 150.805 164.609 141.599 173.001 132.69Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M187.498 91.492H192.016C193.326 91.4917 194.574 92.0479 195.449 93.0221C196.325 93.9962 196.745 95.2965 196.606 96.5988L195.12 110.481C194.961 111.97 195.534 113.444 196.656 114.435C198.165 115.765 198.637 117.919 197.824 119.759L193.714 129.073L187.498 91.492Z"
          fill="#AA90FA"
          stroke="#272D41"
        />
        <path
          d="M173.197 90.2379L168.816 91.3836C167.549 91.7156 166.483 92.5704 165.883 93.7348C165.283 94.8992 165.207 96.2637 165.672 97.488L170.627 110.539C171.159 111.939 170.98 113.509 170.146 114.753C169.023 116.422 169.111 118.626 170.363 120.2L176.699 128.151L173.197 90.2379Z"
          fill="#AA90FA"
          stroke="#272D41"
        />
        <path
          d="M187.751 177.705C187.751 177.705 187.751 186.607 177.324 187.37C179.359 202.119 188.89 243.827 167.407 291.64"
          stroke="#272D41"
        />
        <path
          d="M206.061 172.873C206.061 172.873 228.107 257.952 228.144 288.781"
          stroke="#272D41"
        />
        <path
          d="M176.052 47.4925L189.37 55.1619C190.472 55.7519 191.843 55.3636 192.471 54.2836C193.065 53.2604 192.794 51.9539 191.842 51.2513L186.002 46.9721C184.694 46.0134 183.025 45.6935 181.455 46.1011L176.052 47.4925Z"
          fill="#EBA687"
          stroke="#272D41"
        />
        <path
          d="M186.573 57.1965C187.674 57.7865 189.045 57.3982 189.674 56.3183C190.268 55.295 189.997 53.9885 189.045 53.2859L179.915 46.7803C177.334 44.9419 173.842 45.0589 171.389 47.0659L170.967 47.4815"
          fill="#EBA687"
        />
        <path
          d="M186.573 57.1965C187.674 57.7865 189.045 57.3982 189.674 56.3183C190.268 55.295 189.997 53.9885 189.045 53.2859L179.915 46.7803C177.334 44.9419 173.842 45.0589 171.389 47.0659L170.967 47.4815"
          stroke="#272D41"
        />
        <path
          d="M167.801 54.3231L184.874 59.1626C186.07 59.5438 187.353 58.9027 187.765 57.7169C188.158 56.6048 187.655 55.3749 186.594 54.858L172.138 47.9296L167.801 54.3231Z"
          fill="#EBA687"
        />
        <path
          d="M171.729 55.122L184.87 59.1627C186.067 59.5439 187.349 58.9028 187.762 57.717C188.155 56.6059 187.653 55.3763 186.594 54.8582L172.138 47.9297C169.727 46.7178 166.832 47.0244 164.728 48.714L157.995 54.0992L130.021 59.1952"
          stroke="#272D41"
        />
        <path d="M158.049 53.9945L159.065 61.6241" stroke="#272D41" />
        <path
          d="M278.985 54.7159C278.985 54.7159 288.495 56.3372 283.849 70.4132C284.603 73.957 285.344 78.2073 285.822 80.2838C286.012 81.1068 285.83 81.9719 285.324 82.6483C284.818 83.3248 284.04 83.7439 283.197 83.794L274.82 84.2936L273.433 60.7385"
          fill="#272D41"
        />
        <path
          d="M278.985 54.7159C278.985 54.7159 288.495 56.3372 283.849 70.4132C284.603 73.957 285.344 78.2073 285.822 80.2838C286.012 81.1068 285.83 81.9719 285.324 82.6483C284.818 83.3248 284.04 83.7439 283.197 83.794L274.82 84.2936L273.433 60.7385"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M263.598 72.0551L263.034 92.011L275.962 95.8384L274.519 71.6222"
          fill="#EBA687"
        />
        <path
          d="M275.962 95.8384L274.519 71.6222"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M275 79.8241C275 79.8241 271.747 80.3266 269.258 78.9559C270.134 82.6257 275.407 86.5822 275.407 86.5822L275 79.8241Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <ellipse
          cx="8.63175"
          cy="8.63175"
          rx="8.63175"
          ry="8.63175"
          transform="matrix(-0.960511 0.278242 0.278242 0.960511 278.109 60.9565)"
          fill="#EBA687"
        />
        <path
          d="M269.31 79.7795C272.607 80.9599 276.291 80.0316 278.635 77.4295C280.979 74.8275 281.52 71.0672 280.003 67.9104C278.486 64.7536 275.213 62.8256 271.717 63.0298"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M273.484 67.3593C272.019 67.5199 270.89 68.7241 270.824 70.1959C270.717 73.1003 270.04 73.4197 270.04 73.4197C270.04 73.4197 269.976 68.8279 267.98 68.2858C265.985 67.7437 264.916 71.9739 267.819 72.8955L268.323 81.3754C268.386 82.3542 268.044 83.3158 267.376 84.0346C266.709 84.7534 265.775 85.166 264.794 85.1758L258.38 85.2619C257.353 85.2764 256.369 84.8483 255.68 84.0868C254.991 83.3253 254.662 82.304 254.778 81.2835L256.734 64.1676C257.107 59.4508 260.899 55.7301 265.622 55.4479C268.966 55.2261 273.153 54.9657 277.337 54.7504L277.669 54.7299C281.045 54.5301 283.945 57.1034 284.148 60.4792C284.339 63.7945 281.853 66.658 278.544 66.9345L273.484 67.3593Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M295.915 155.975C295.915 155.975 300.9 191.799 300.089 204.448C238.512 210.223 233.872 206.314 233.872 206.314L243.922 160.417"
          fill="#2164DA"
        />
        <path
          d="M295.915 155.975C295.915 155.975 300.9 191.799 300.089 204.448C238.512 210.223 233.872 206.314 233.872 206.314L243.922 160.417"
          stroke="#272D41"
        />
        <path
          d="M330.367 50.1608L330.583 106.869L272.836 92.4472L282.425 124.408L326.598 131.705C342.67 134.361 356.95 121.192 355.606 104.959L355.318 101.506L349.261 49.9687"
          fill="#EBA687"
        />
        <path
          d="M330.367 50.1608L330.583 106.869L272.836 92.4472L282.425 124.408L326.598 131.705C342.67 134.361 356.95 121.192 355.606 104.959L355.318 101.506L349.261 49.9687"
          stroke="#272D41"
        />
        <path
          d="M346.924 45.3518L358.443 30.9859C359.116 30.1475 358.991 28.9238 358.162 28.2394C357.385 27.5999 356.252 27.6486 355.533 28.3522L342.727 40.8982L346.924 45.3518Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M346.65 41.5571L349.051 36.9336L350.203 34.7107L355.131 25.2136C355.628 24.2612 355.268 23.0863 354.323 22.5755C353.436 22.1012 352.334 22.3705 351.766 23.2004L341.667 38.0136L346.65 41.5571Z"
          fill="#EBA687"
        />
        <path
          d="M349.411 36.2483L350.209 34.7116L355.137 25.2145C355.633 24.2603 355.271 23.0843 354.323 22.5755C353.436 22.1012 352.334 22.3705 351.766 23.2004L341.667 38.0136L346.65 41.5571"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M343.929 38.0664L350.544 20.8837C350.936 19.877 350.443 18.7427 349.44 18.3421C348.507 17.9693 347.443 18.3599 346.974 19.2476L338.561 35.0948L343.929 38.0664Z"
          fill="#EBA687"
        />
        <path
          d="M345.711 33.3978L350.53 20.8814C350.921 19.8747 350.429 18.7405 349.425 18.3398C348.493 17.9671 347.429 18.3576 346.959 19.2454L338.561 35.0948L343.929 38.0664"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M340.114 35.898L344.417 21.2568C344.718 20.2282 344.152 19.1453 343.135 18.8064C342.171 18.4847 341.12 18.9388 340.693 19.8609L334.809 32.6308L340.114 35.898Z"
          fill="#EBA687"
        />
        <path
          d="M351.629 39.4865L335.451 31.3575L329.722 42.1804L330.447 54.6072L349.335 52.289C351.709 48.6696 352.568 44.2642 351.731 40.0179L351.629 39.4865Z"
          fill="#EBA687"
        />
        <path
          d="M344.314 52.8475L349.329 52.2731C351.702 48.6537 352.562 44.2483 351.724 40.002L351.622 39.4764L343.657 35.3926"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M337.137 53.7785L334.322 35.3886C334.028 33.4731 332.264 32.1384 330.341 32.3763L329.199 32.5171L330.479 54.5941L337.137 53.7785Z"
          fill="#EBA687"
        />
        <path
          d="M330.405 54.9027L329.205 32.518L330.347 32.3772C332.27 32.1393 334.034 33.474 334.327 35.3895L335.137 40.6686C335.137 40.6686 341.149 39.0035 346.544 44.8186"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M340.998 32.8631L344.408 21.2555C344.71 20.2269 344.144 19.144 343.127 18.8051C342.163 18.4834 341.112 18.9375 340.685 19.8596L333.954 34.3334"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M330.583 106.869L270.516 90.5032L281.193 128.853L328.085 136.564C344.157 139.22 364.382 121.45 362.229 101.126L361.941 97.6705L358.062 64.5699L330.435 68.396L330.583 106.869Z"
          fill="white"
        />
        <path
          d="M283.91 129.264L328.08 136.563C344.152 139.219 364.376 121.449 362.223 101.125L361.936 97.6697L358.062 64.5699L330.435 68.3961L330.583 106.869L272.673 91.0823"
          stroke="#272D41"
        />
        <path
          d="M352.821 57.9694L350.198 57.9705L351.422 68.3995L352.82 68.402C354.203 68.4024 355.53 67.8531 356.508 66.8752C357.486 65.8972 358.036 64.5707 358.035 63.1875C358.036 60.307 355.702 57.9709 352.821 57.9694Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M330.395 57.9659L330.435 68.3961L351.425 68.4L350.199 57.9705L330.395 57.9659Z"
          fill="#EBA687"
        />
        <path
          d="M330.395 57.9659L330.435 68.3961L351.425 68.4L350.199 57.9705"
          stroke="#272D41"
        />
        <path d="M330.589 105.293L330.72 115.891" stroke="#272D41" />
        <path
          d="M301.41 124.393C301.259 118.717 296.57 114.22 290.893 114.304L290.391 110.146C289.127 99.6268 280.057 91.8031 269.467 92.0959C259.241 92.3686 250.781 100.136 249.638 110.3L243.987 160.439L296.274 159.027L293.359 134.786C298.176 133.681 301.544 129.333 301.41 124.393Z"
          fill="white"
        />
        <path
          d="M269.493 92.1001C259.268 92.3727 250.807 100.14 249.664 110.305L244.013 160.443L296.3 159.031L293.36 134.786C298.533 133.603 301.978 128.705 301.343 123.436C300.707 118.167 296.196 114.229 290.889 114.31L290.387 110.151C290.098 107.732 289.379 105.383 288.263 103.217"
          stroke="#272D41"
        />
        <path
          d="M259.745 94.8807L259.888 91.3639C259.928 90.6269 260.268 89.9383 260.828 89.4583C261.389 88.9783 262.121 88.7486 262.856 88.8227L278.93 90.4448C280.317 90.5845 281.37 91.7581 281.358 93.1522L281.31 100.027"
          fill="white"
        />
        <path
          d="M259.745 94.8807L259.888 91.3639C259.928 90.6269 260.268 89.9383 260.828 89.4583C261.389 88.9783 262.121 88.7486 262.856 88.8227L278.93 90.4448C280.317 90.5845 281.37 91.7581 281.358 93.1522L281.31 100.027"
          stroke="#3C4764"
        />
        <path
          d="M281.258 159.438L281.688 171.298C281.749 172.917 281.273 174.51 280.336 175.832L276.414 180.481"
          stroke="#272D41"
        />
        <path d="M275.957 159.583L276.56 189.864" stroke="#272D41" />
        <path
          d="M279.062 122.304C272.423 138.452 262.018 170.237 262.018 170.237L267.768 195.456L270.708 201.556L267.94 214.744L248.071 203.979C229.36 192.46 228.723 169.268 235.031 148.174L250.036 108.564"
          fill="white"
        />
        <path
          d="M279.062 122.304C272.423 138.452 262.018 170.237 262.018 170.237L267.768 195.456L270.708 201.556L267.94 214.744L248.071 203.979C229.36 192.46 228.723 169.268 235.031 148.174L250.036 108.564"
          stroke="#3C4764"
        />
        <rect
          width="107.013"
          height="316.579"
          transform="matrix(-1 0 0 1 604.566 1)"
          fill="#272D41"
          stroke="black"
        />
        <mask
          id="mask4_6647_121640"
          style={{ maskType: "alpha" }}
          maskUnits="userSpaceOnUse"
          x="497"
          y="0"
          width="108"
          height="319"
        >
          <rect
            width="106"
            height="317"
            transform="matrix(-1 0 0 1 604 1)"
            fill="white"
            stroke="black"
          />
        </mask>
        <g mask="url(#mask4_6647_121640)">
          <rect
            x="494.961"
            y="0.5"
            width="58.9261"
            height="198"
            fill="#2164DA"
            stroke="#272D41"
          />
          <path d="M538 1.5V54.5" stroke="#272D41" />
          <path d="M524 1V69.5" stroke="#272D41" />
          <path d="M512.5 1V44" stroke="#272D41" />
          <path
            d="M605.171 105.755C569.808 77.267 552.803 58.2496 544.1 1H605.171V105.755Z"
            fill="#2164DA"
            stroke="#272D41"
          />
          <path
            d="M558.612 1.58524C564.5 26.7246 570.514 40.0135 589.45 61.2783M585.217 20.3125C589.908 34.1757 593.534 40.5465 604.567 45.4772"
            stroke="#272D41"
          />
          <path
            d="M584.35 202.5C586.888 166.767 591.916 146.733 603.465 111L607.597 110L614.313 206L584.35 202.5Z"
            fill="#2164DA"
            stroke="#272D41"
          />
          <rect
            x="600.882"
            y="105"
            width="13.4317"
            height="7"
            rx="2"
            fill="#2164DA"
            stroke="#272D41"
          />
        </g>
        <rect
          width="107.013"
          height="316.579"
          transform="matrix(-1 0 0 1 604.567 1)"
          stroke="black"
        />
        <path
          d="M495.58 114.173C490.679 116.862 461.325 126.744 461.325 126.744L456.109 137.297L456.542 160.452L437.9 161.57C416.933 162.042 409.801 142.206 416.633 125.388C423.413 108.698 441.288 101.966 488.75 82.8578"
          fill="#272D41"
        />
        <path
          d="M501.231 111.669C497.381 114.871 461.738 126.548 461.738 126.548L456.452 137.135L456.814 160.323C442.543 161.22 428.676 164.411 418.454 152.074C413.285 145.836 412.319 135.25 417.25 124.155C422.181 113.06 434.452 102.582 488.133 82.8577"
          stroke="#272D41"
        />
        <path
          d="M460.79 127.079L426.545 129.637L460.79 127.079Z"
          fill="white"
        />
        <path d="M460.79 127.079L426.545 129.637" stroke="#3C4764" />
        <path
          d="M484.408 125.503L484.857 128.185L484.408 125.503Z"
          fill="#EBA687"
        />
        <path
          d="M484.408 125.503L484.857 128.185"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M457.442 308.473C451.021 247.2 460.068 195.26 473.585 162.566C503.654 138.484 520.208 135.744 520.208 135.744L501.193 280.192L504.107 311.977"
          fill="#272D41"
        />
        <path
          d="M457.442 308.473C451.021 247.2 460.068 195.26 473.585 162.566C503.654 138.484 520.208 135.744 520.208 135.744L501.193 280.192L504.107 311.977"
          stroke="#272D41"
        />
        <path
          d="M507.338 259.746L501.209 280.192L503.262 302.406C503.262 302.406 489.55 283.09 487.799 256.534C486.047 229.978 490.959 179.441 490.959 179.441L507.332 190.009L507.338 259.746Z"
          fill="#272D41"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M565.102 302.348L550.805 278.712L549.736 201.768C550.052 189.801 547.668 177.917 542.762 166.998L541.169 163.437L498.276 161.397C498.276 161.397 486.921 252.561 511.317 298.741C514.231 304.245 517.213 309.662 520.224 314.93"
          fill="#272D41"
        />
        <path
          d="M565.102 302.348L550.805 278.712L549.736 201.768C550.052 189.801 547.668 177.917 542.762 166.998L541.169 163.437L498.276 161.397C498.276 161.397 486.921 252.561 511.317 298.741C514.231 304.245 517.213 309.662 520.224 314.93"
          stroke="#272D41"
        />
        <path
          d="M537.973 308.474C508.51 268.206 517.55 211.018 521.927 184.754L519.599 184.174C515.429 183.13 512.422 179.497 512.175 175.206L512.004 172.208"
          fill="#272D41"
        />
        <path
          d="M537.973 308.474C508.51 268.206 517.55 211.018 521.927 184.754L519.599 184.174C515.429 183.13 512.422 179.497 512.175 175.206L512.004 172.208"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M490.997 163.453L489.702 184.323C489.589 186.132 489.977 187.937 490.823 189.539L495.776 198.929L497.994 163.443"
          fill="#272D41"
        />
        <path
          d="M490.997 163.453L489.702 184.323C489.589 186.132 489.977 187.937 490.823 189.539L495.776 198.929L497.994 163.443"
          stroke="#272D41"
        />
        <path
          d="M477.865 308.474C467.647 239.319 483.994 163.453 483.994 163.453L477.865 308.474Z"
          fill="#272D41"
        />
        <path
          d="M477.865 308.474C467.647 239.319 483.994 163.453 483.994 163.453"
          stroke="#272D41"
        />
        <path
          d="M541.143 163.453H473.449L479.371 99.9936C480.648 86.3504 492.098 75.9201 505.8 75.9179C519.034 75.9254 530.241 85.6773 532.078 98.7827L541.143 163.453Z"
          fill="white"
        />
        <path
          d="M541.143 163.453H473.449L479.371 99.9936C480.648 86.3504 492.098 75.9201 505.8 75.9179C519.034 75.9254 530.241 85.6773 532.078 98.7827L541.143 163.453Z"
          fill="#272D41"
        />
        <path
          d="M505.8 75.918C519.034 75.9255 530.241 85.6774 532.078 98.7828L541.143 163.453H473.449L478.888 108.746"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M547.337 180.104H538.851V205.171C538.851 208.449 540.507 211.505 543.254 213.294L549.966 217.668L551.459 200.7C551.995 194.642 551.009 188.546 548.59 182.967L547.337 180.104Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M484.435 132.785L489.366 85.3233L498.612 80.3923L504.776 85.3233L499.228 135.25L484.435 132.785Z"
          fill="white"
          stroke="#3C4764"
        />
        <path
          d="M498.001 75.6266L489.663 78.5761C488.682 78.9232 487.941 79.739 487.688 80.7487L487.102 83.0863C486.957 83.6672 487.151 84.2804 487.604 84.6718C488.057 85.0633 488.692 85.1664 489.246 84.9383L496.262 82.047L498.001 75.6266Z"
          fill="white"
          stroke="#3C4764"
          strokeLinecap="round"
        />
        <path
          d="M503.252 74.1664L494.206 86.7125L492.454 80.0007"
          fill="white"
        />
        <path
          d="M503.252 74.1664L494.206 86.7125L492.454 80.0007"
          stroke="#3C4764"
          strokeLinecap="round"
        />
        <path
          d="M480.984 155.516C461.445 142.537 450.46 135.403 429.613 128.47C433.892 112.444 460.861 114.738 471.491 117.991L498.473 127.831L506.008 108.129L532.513 117.991L530.444 133.987C526.545 154.704 504.206 166.223 485.066 157.407L480.984 155.516Z"
          fill="#EBA687"
          stroke="#272D41"
        />
        <path
          d="M517.72 79.1595C536.827 84.7069 541.142 99.5001 531.896 135.25C527.998 155.967 511.038 178.688 486.097 170.974L456.001 159.726L465.855 147.899L471.522 117.886L498.473 127.831L509.09 92.1033"
          fill="#272D41"
        />
        <path
          d="M498.473 127.831L471.522 117.886L465.855 147.899L456.001 159.726L486.097 170.974C511.038 178.688 526.745 154.944 531.896 134.017C537.047 113.091 544.486 86.2159 517.103 78.543"
          stroke="#272D41"
        />
        <path
          d="M449.991 151.131L452.383 138.332L465.944 145.728L464.719 153.915C463.95 157.98 460.032 160.654 455.965 159.887C454.012 159.518 452.285 158.388 451.165 156.746C450.044 155.104 449.622 153.084 449.991 151.131Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M456.082 145.112L462.245 116.142L472.107 117.991L465.944 147.577L456.082 145.112Z"
          fill="white"
          stroke="#3C4764"
        />
        <path
          d="M497.361 124.654L494.358 119.803L482.415 117.097C480.768 116.723 476.756 117.777 477.038 119.84C483.957 123.495 493.681 129.086 497.361 124.654Z"
          fill="#EBA687"
        />
        <path
          d="M496.823 120.403C498.683 121.204 499.77 123.156 499.472 125.158L498.555 131.322C498.422 132.399 497.459 133.177 496.378 133.08C495.358 132.995 494.566 132.158 494.537 131.135L492.43 119.339L496.823 120.403Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M492.077 119.203C493.769 119.65 494.943 121.186 494.93 122.936L494.854 131.233C494.886 132.408 493.983 133.397 492.811 133.473C491.698 133.544 490.711 132.766 490.519 131.668L486.871 118.201L492.077 119.203Z"
          fill="#EBA687"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M486.872 118.161C488.666 118.523 490.03 119.987 490.265 121.801L491.516 131.075C491.692 132.236 490.919 133.328 489.766 133.549C488.67 133.756 486.358 132.332 486.033 131.267L481.699 120.808C481.369 120.009 481.508 119.093 482.059 118.427C482.611 117.761 483.486 117.454 484.333 117.63L486.872 118.161Z"
          fill="#EBA687"
        />
        <path
          d="M482.319 117.115L486.861 118.152C488.654 118.514 490.019 119.978 490.253 121.793L491.504 131.067C491.681 132.227 490.908 133.32 489.754 133.54C488.659 133.747 487.584 133.097 487.257 132.032L484.811 123.075"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M482.366 117.226C484.16 117.588 485.524 119.052 485.759 120.867L487.01 130.141C487.186 131.301 486.413 132.394 485.26 132.614C484.164 132.821 482.217 131.022 481.903 129.966L480.55 122.545L478.859 120.245L482.366 117.226Z"
          fill="#EBA687"
        />
        <path
          d="M482.366 117.226C484.16 117.588 485.524 119.052 485.759 120.867L487.01 130.141C487.186 131.301 486.413 132.394 485.26 132.614C484.166 132.823 483.091 132.174 482.766 131.109L480.317 122.149C480.366 121.858 480.122 121.195 478.751 120.867"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path d="M494.297 86.556L491.215 115.526" stroke="#272D41" />
        <path
          d="M482.586 84.7069L485.668 89.6379L479.504 95.8017L485.668 117.375"
          stroke="#272D41"
        />
        <path
          d="M520.185 79.7759L509.09 90.2543L512.788 95.1853L499.844 122.922"
          stroke="#272D41"
        />
        <path
          d="M482.042 40.7793C482.042 40.7793 477.694 54.5234 490.839 57.8097C496.237 56.6376 490.603 43.9619 490.603 43.9619L482.042 40.7793Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <path
          d="M496.473 82.9214V56.8707"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M508.206 56.6376L510.084 77.9936L496.47 82.9246V56.8707"
          fill="#EBA687"
        />
        <path
          d="M508.206 56.6376L510.084 77.9936"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M496.473 65.6935C496.473 65.6935 499.992 66.0173 502.573 64.3822C501.87 68.3711 496.473 72.9525 496.473 72.9525V65.6935Z"
          fill="#272D41"
          stroke="#272D41"
        />
        <ellipse
          cx="498.937"
          cy="56.7541"
          rx="9.26959"
          ry="9.26959"
          fill="#EBA687"
        />
        <path
          d="M502.573 65.2823C499.115 66.7442 495.117 65.9761 492.447 63.3369C489.777 60.6978 488.962 56.7087 490.384 53.2341C491.806 49.7595 495.183 47.4855 498.937 47.4749"
          stroke="#272D41"
          strokeLinecap="round"
        />
        <path
          d="M508.909 64.1459C508.909 64.1459 503.981 64.1459 503.748 57.8097C506.798 56.6376 505.39 52.1793 503.279 52.8818C501.168 53.5844 501.401 58.5155 501.401 58.5155C501.401 58.5155 499.523 55.9253 499.992 51.2403H488.761C486.884 51.2403 485.084 50.4945 483.757 49.1671C482.43 47.8397 481.685 46.0395 481.686 44.1627C481.685 39.8764 483.388 35.7653 486.418 32.7341C489.449 29.7029 493.559 28 497.846 28C510.311 28 519.538 39.7043 516.501 51.7972C515.371 56.3171 513.086 60.7009 508.909 64.1459Z"
          fill="#AA90FA"
          stroke="#272D41"
        />
        <path
          d="M494.316 86.4211L495.611 83.0572C496.21 81.4882 497.459 80.2561 499.037 79.6802L512.227 74.8722C513.633 74.462 515.133 75.0983 515.815 76.3939L515.993 76.7371C516.823 78.3329 516.449 80.2899 515.089 81.4674L509.909 85.9128C508.422 87.1939 506.211 87.1577 504.767 85.8286L502.465 83.7112C501.242 82.5872 499.38 82.5279 498.088 83.5719L494.452 86.515C494.423 86.5432 494.379 86.547 494.345 86.5241C494.312 86.5012 494.3 86.4581 494.316 86.4211Z"
          fill="white"
          stroke="#3C4764"
          strokeLinecap="round"
        />
        <path
          d="M256.943 146.966L256.943 137.602C310.649 144.523 340.437 145.133 392.715 137.602L392.715 146.966C340.053 153.495 310.316 153.362 256.943 146.966Z"
          fill="#AA90FA"
          stroke="#272D41"
        />
        <rect
          x="392.715"
          y="134.091"
          width="7.02271"
          height="67.8862"
          fill="#272D41"
          stroke="#272D41"
        />
        <circle
          cx="396.226"
          cy="132.92"
          r="6.52271"
          fill="#272D41"
          stroke="#272D41"
        />
        <rect
          x="251.09"
          y="134.091"
          width="7.02271"
          height="67.8862"
          fill="#272D41"
          stroke="#272D41"
        />
        <circle
          cx="254.602"
          cy="132.92"
          r="6.52271"
          fill="#272D41"
          stroke="#272D41"
        />
      </g>
      <defs>
        <clipPath id="clip0_6647_121640">
          <rect width="680" height="192" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
